import React from 'react';
import { useDateFormatter } from '@atlassian/jira-portfolio-3-common/src/date-manipulation/format.tsx';
import type { Props } from '@atlassian/jira-portfolio-3-common/src/date-picker/types';
import GenericReadonlyCell from '@atlassian/jira-portfolio-3-portfolio/src/app-export-view/view/component-slot-content/generic-readonly-cell';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';

export default function FieldDatePicker({ value }: Props) {
	const { formatDate } = useDateFormatter();
	// If the date is a rollup date, sprint or release inferred dates,
	// it's taken care of by renderInferredDate in src/packages/portfolio-3/portfoli o/src/app-simple-plans/view/main/tabs/roadmap/fields/columns/cells/date/view.js
	const date = isDefined(value) && value !== '' ? formatDate(value) : '';
	return <GenericReadonlyCell text={date} />;
}
